import { Typography } from "antd";

import { RVTimeDisplay } from "../../../../atoms/RVTimeDisplay/RVTimeDisplay";

interface AuditBase {
    /** ISO timestamp string representing when the action occurred. */
    timestamp: string;
    /** Person or system responsible for the action. */
    name: string;
}

type RVGridCellAuditInfoProps = {
    /** Audit metadata containing the timestamp and actor information. */
    auditInfo: AuditBase;
    /** Identifier used to ensure stable keys when rendering multiple audit rows. */
    id: string;
};
/**
 * Displays audit metadata with a relative time stamp followed by the actor name.
 */
export const RVGridCellAuditInfo = ({ auditInfo, id }: RVGridCellAuditInfoProps) => {
    return (
        <>
            <RVTimeDisplay time={auditInfo.timestamp} key={`${id}-${auditInfo.timestamp}`} />
            <br />
            <Typography.Text>{auditInfo.name}</Typography.Text>
        </>
    );
};
